import { MeteoConditions } from '@models/MeteoConditions'
import { MeteoConditionsDTO } from '../MeteoConditionsDTO'

export interface MeteoConditionsSendDTO {
  ID: MeteoConditionsDTO['ID']
  VARIABLE?: MeteoConditionsDTO['ID']
  VALORES: MeteoConditionsDTO['VALORES']
  DECIMALES?: MeteoConditionsDTO['DECIMALES']
}

export namespace MeteoConditionsSendDTO {
  export function fromMeteoConditionsDTO(
    dto: MeteoConditionsDTO
  ): MeteoConditionsSendDTO {
    return {
      ID: dto.ID,
      VARIABLE: dto.ID,
      VALORES: dto.VALORES,
      DECIMALES: dto.DECIMALES
    }
  }
  export function fromMeteoConditions(
    dto: MeteoConditions
  ): MeteoConditionsSendDTO {
    return {
      ID: dto.id,
      VARIABLE: dto.id,
      VALORES: dto.values,
      DECIMALES: dto.decimals
    }
  }
}
